import _ from 'lodash';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import BeeButton from '../../Atoms/BeeButton';
import BeeValidatedCheckbox from '../../Atoms/BeeValidatedCheckbox';
import {
  USER_RIGHT_DLREAD,
  USER_RIGHT_DLWRITE_KEYVAL,
  USER_RIGHT_DLWRITE_MEDIA
} from '../../../Helper/Statics/Constants';
import { User, UserRight } from '../../../Helper/ApiHelper/AuthServiceHelper';
import './AlphaUserImportDialog.scss';

type AlphaUserImportDialogProps = {
  visible: boolean;
  allUserFromEntryService: User[];
  onHide: () => void;
  onImport: (selectedUsers: User[]) => void;
};

export default function AlphaUserImportDialog({
  visible,
  allUserFromEntryService,
  onHide,
  onImport
}: AlphaUserImportDialogProps) {
  const toast = useRef<Toast>(null);
  const [selectedUsers, setSelectedUsers] = useState<User[]>([]);

  useEffect(() => {
    if (visible) {
      setSelectedUsers([]);
    }
  }, [visible]);

  function handleHide() {
    setSelectedUsers([]);
    onHide();
  }

  function handleImport() {
    if (!selectedUsers || selectedUsers.length === 0) return;
    const payload = _.cloneDeep(selectedUsers);
    onImport(payload);
    handleHide();

    if (toast.current) {
      toast.current.show({
        severity: 'success',
        summary: 'Nutzer für Import ausgewählt',
        detail: 'Der Import wurde vorbereitet (Mock).',
        sticky: false
      });
    }
  }

  function hasRight(rights: UserRight[] | undefined, title: string): boolean {
    if (!rights) return false;
    return rights.some((r) => r.title === title);
  }

  /////////////////////
  //////// UI /////////
  /////////////////////

  function registrationBodyTemplate(rowData: User) {
    const date = rowData.registration ? new Date(rowData.registration) : null;
    return date ? date.toLocaleDateString('de-DE') : null;
  }

  function rightReadBodyTemplate(rowData: User) {
    const value = hasRight(rowData.grantedRights, USER_RIGHT_DLREAD);
    return (
      <BeeValidatedCheckbox
        label={''}
        value={value}
        stateFalse={''}
        stateTrue={''}
        disabled={true}
        formstate={'neutral'}
        readOnly={true}
      />
    );
  }

  function rightWriteBodyTemplate(rowData: User) {
    const rights = rowData.grantedRights ?? [];
    const value =
      rights.some((r) => r.title === USER_RIGHT_DLWRITE_KEYVAL) &&
      rights.some((r) => r.title === USER_RIGHT_DLWRITE_MEDIA);
    return (
      <BeeValidatedCheckbox
        label={''}
        value={value}
        stateFalse={''}
        stateTrue={''}
        disabled={true}
        formstate={'neutral'}
        readOnly={true}
      />
    );
  }

  return (
    <Dialog
      header={'Nutzer importieren'}
      visible={visible}
      modal={true}
      className={
        'alpha-user-import-dialog bee-dialog-secondary bee-dialog-large'
      }
      onHide={() => handleHide()}
    >
      <div>
        <div className="mb-2 ">
          Wählen Sie die Nutzer aus, die in die Plattform übernommen werden
          sollen.
        </div>

        <DataTable
          value={allUserFromEntryService}
          emptyMessage={'Keine Nutzer verfügbar'}
          className="alpha-user-import-dialog__table bee-table-light"
          responsiveLayout="stack"
          breakpoint="730px"
          selection={selectedUsers}
          onSelectionChange={(e) => {
            const v = e.value as User[];
            setSelectedUsers(v ?? []);
          }}
        >
          <Column selectionMode="multiple" style={{ width: '3.5rem' }} />
          <Column field="firstname" header="Vorname" />
          <Column field="lastname" header="Nachname" />
          <Column field="organisation" header="Organisation" />
          <Column field="username" header="E-Mail" />
          <Column
            field="registration"
            header="Registriert am"
            body={registrationBodyTemplate}
          />
          {/*     <Column header="Leserecht" body={rightReadBodyTemplate} />
          <Column header="Schreibrecht" body={rightWriteBodyTemplate} /> */}
        </DataTable>

        <div className="flex justify-content-end gap-2 mt-4">
          <BeeButton
            type={'secondary'}
            label={'Abbrechen'}
            disabled={false}
            isLoading={false}
            onClick={() => handleHide()}
          />
          <BeeButton
            type={'primary'}
            label={'Importieren'}
            disabled={!selectedUsers || selectedUsers.length === 0}
            isLoading={false}
            onClick={() => handleImport()}
          />
        </div>
      </div>

      <Toast ref={toast} position={'top-right'} />
    </Dialog>
  );
}
